import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { defaultsDeep } from "__barrel_optimize__?names=defaultsDeep!=!lodash-es";
export const popupReducer = {
  pushStack: (() => {
    let id = 1;
    return (state, payload) => {
      const defaultOption = {
        drawerAttributes: {},
        id: id++
      };
      state.showStacks.push(Object.assign(defaultOption, payload));
      // state.showStacks.push({...merge(defaultOption, payload)}) // 不可变类型,报错
    };
  })(),
  popStack(state) {
    state.showStacks.pop();
  },
  changeStack(state, payload) {
    const {
      hierarchy = 1,
      ...rest
    } = payload;
    const stacks = state.showStacks;
    const idx = stacks.length - hierarchy;
    if (idx < 0 || idx > stacks.length - 1) {
      return;
    }
    for (const key in rest) {
      stacks[idx][key] = rest[key];
    }
  },
  closeStack(state) {
    this.changeStack(state, {
      visible: false
    });
  }
};
export const usePopups = create()(immer(set => ({
  popups: [],
  showStacks: [],
  curActive: undefined,
  dispatch: action => {
    const actions = action instanceof Array ? action : [action];
    actions.forEach(action => {
      const finalAction = defaultsDeep(action, defaultParams);
      const {
        type,
        payload
      } = finalAction;
      set(state => {
        popupReducer[type](state, payload);
      });
    });
  }
})));
const defaultParams = {
  type: "",
  payload: {
    type: "ss",
    visible: true,
    drawerAttributes: {
      placement: "bottom",
      height: "100%",
      style: {
        background: "transparent",
        width: "auto",
        height: "auto",
        bottom: 0,
        top: 0,
        right: 0,
        left: 0
      },
      maskStyle: {
        background: "rgba(0, 0, 0, 0.3)",
        backdropFilter: "blur(12px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      headerStyle: {
        background: "#000"
      },
      bodyStyle: {
        padding: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden"
      },
      maskClosable: true,
      escToExit: true
    }
  }
};